import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule }           from '@angular/common';
import { OverlayModule}           from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS }      from '@angular/common/http';

import { NgcCookieConsentModule } from 'ngx-cookieconsent';

// Interceptors
import { HttpErrorInterceptor } from 'src/app/core/interceptors/http-error.interceptor';
import { ErrorInterceptor }     from 'src/app/core/interceptors/error.interceptor';

// Services
import { CookieService }           from 'ngx-cookie-service';
import { ThemeManagerService }     from './services/styles/theme-manager.service';
import { AppConfigurationService } from './services/configuration/app-configuration.service';
import { AreaResourceService }     from './services/api/area-resource.service';
import { CampusResourceService }   from './services/api/campus-resource.service';
import { CampusService }           from './services/api/campus.service';
import { CourseResourceService }   from './services/api/course-resource.service';
import { CourseService }           from './services/api/course.service';
import { ClassService }            from './services/api/class.service';
import { EditionResourceService }  from './services/api/edition-resource.service';
import { WebResourceService }      from './services/api/web-resource.service';

// Models
import { CookieConsentConfiguration } from './models/cookie-consent-configuration.model';

@NgModule({

    declarations: [

    ],

    imports: [
        CommonModule,
        OverlayModule,
        NgcCookieConsentModule.forRoot(CookieConsentConfiguration)
    ],

    providers: [
        CookieService,
        ThemeManagerService,
        AppConfigurationService,
        AreaResourceService,
        CampusResourceService,
        CampusService,
        CourseResourceService,
        CourseService,
        ClassService,
        EditionResourceService,
        WebResourceService,
        {
			provide: HTTP_INTERCEPTORS,
			useClass: HttpErrorInterceptor,
			multi: true
		},
		{
			provide: ErrorHandler,
			useClass: ErrorInterceptor
		}
    ]

})

export class CoreModule { }
